import { services } from '@/utils'

import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderTitle(h) {
  return h(
    sticker,
    {
      props: {
        value: this.value,
        label: this.getTranslate(`${services.routingGroups}.labels.title`),
        iconSVG: this.value.type,
        color: this.value.type,
        service: services.routingGroups,
        width: 'fit-content'
      }
    }
  )
}
function renderDescription(h) {
  if (this.value.description) {
    return h(
      sticker,
      {
        props: {
          value: this.value.description,
          label: this.getTranslate(`${services.routingGroups}.labels.description`),
          width: 'fit-content',
          maxWidth: 400
        }
      }
    )
  }

  return h('div')
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: 'service-template-item hover-parent hover-parent--opacity',
      style: { gridTemplateColumns: 'auto 1fr auto' }
    },
    [
      renderTitle.call(this, h),
      renderDescription.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
